import React from 'react';
import Page from '../../../src/hocs/defaultPage';
import Email from '../../../src/containers/ForgotPassword/Email';

const Index = Page(() => <Email />);
export default Index;
